(function() {
  'use strict';

  angular
    .module('quiz.trueFalse', [])
    .controller('TrueFalseCtrl', TrueFalseCtrl);

  TrueFalseCtrl.$inject = ['$scope'];

  function TrueFalseCtrl($scope) {
    $scope.answerValues = ['true', 'false'];
    $scope.answerModel = '';
    $scope.falseClass = '';
    $scope.trueClass = '';

    var correctAnswerButtonClass = 'btn-correct-answer';
    var incorrectAnswerButtonClass = 'btn-incorrect-answer';

    $scope.$watch('answerModel', answerModelChanged);
    $scope.$watch('state', stateChanged);
    $scope.$watch('state.showAnswersRequested', setAnswerClasses);

    function answerModelChanged(newValue) {
      if (!newValue || $scope.state.answerSubmitted) {
        return;
      }

      $scope.state.answerSelected = true;
      $scope.answer.selectedAnswer = newValue === 'true';
      $scope.storeSelectedAnswer();
    }

    function stateChanged(newValue) {
      if (!newValue) {
        return;
      }

      if (!$scope.state.answerGraded) {
        $scope.falseClass = '';
        $scope.trueClass = '';
        return;
      }

      $scope.answerModel = '';
      setAnswerClasses();
    }

    function setAnswerClasses() {
      if (!$scope.state.answerGraded) {
        return;
      }

      // test and refactor
      if ($scope.state.showAnswersRequested) {
        $scope.falseClass = $scope.question.correctAnswer === false ? correctAnswerButtonClass : 'btn-answered';
        $scope.trueClass = $scope.question.correctAnswer === true ? correctAnswerButtonClass : 'btn-answered';
      } else {
        $scope.falseClass = $scope.answer.selectedAnswer === false ?
          ($scope.state.name === 'answerCorrect' ? correctAnswerButtonClass : incorrectAnswerButtonClass) : 'btn-answered';
        $scope.trueClass = $scope.answer.selectedAnswer === true ?
          ($scope.state.name === 'answerCorrect' ? correctAnswerButtonClass : incorrectAnswerButtonClass) : 'btn-answered';
      }
    }

    $scope.$on('$destroy', function() {
      // console.log('quiz.trueFalse destroy');
    });
  }
})();
